var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3BBDAEF4-625F-4561-9EA1-9009C09D61D9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logins---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Portal---Desktop---Logins---V2",
    transform: "translate(-1199.000000, -984.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars/Footer",
    transform: "translate(0.000000, 960.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-Media",
    transform: "translate(1191.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_linkedin",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6326172,4.9828125 L3.6326172,15.3017578 L0.202734375,15.3017578 L0.202734375,4.9828125 L3.6326172,4.9828125 Z M12.0513672,4.740625 C14.3078125,4.740625 16,6.21552735 16,9.3850586 L16,9.3850586 L16,15.3017578 L12.5704102,15.3017578 L12.5704102,9.7814453 C12.5704102,8.39423827 12.0740235,7.44794922 10.8329102,7.44794922 C9.88535155,7.44794922 9.32109375,8.0861328 9.07314453,8.70214845 C8.98251953,8.9227539 8.96015625,9.23076172 8.96015625,9.5392578 L8.96015625,9.5392578 L8.96015625,15.3017578 L5.5303711,15.3017578 L5.5303711,4.9828125 L8.96035155,4.9828125 L8.96035155,6.47929687 C8.96035155,6.47929687 10.2010742,4.740625 12.0513672,4.740625 Z M1.94033203,0.008300775 C3.11376953,0.008300775 3.83583985,0.77871095 3.85820313,1.7913086 C3.85820313,2.78154297 3.11376953,3.57392577 1.91757813,3.57392577 L1.91757813,3.57392577 L1.8953125,3.57392577 C0.744238275,3.57392577 2.13162821e-14,2.78154297 2.13162821e-14,1.7913086 C2.13162821e-14,0.77871095 0.76708985,0.008300775 1.94033203,0.008300775 Z",
    id: "Combined-Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.730246edf7aad4f1f5cd1163471082a1.svg";
export { ForwardRef as ReactComponent };